<script>
import ProductCell from '@components/product-cell.vue'

export default {
  components: { ProductCell },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
}
</script>

<template>
  <v-container grid-list-md>
    <ProductCell
      v-for="item in products"
      :key="item.id"
      :product="item"
    ></ProductCell>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.productList {
  display: flex;
  flex-direction: column;
}
</style>
